import React from "react";
import { useIntl } from "react-intl";
import { Typography } from "@mui/material";

const EmptyPlaceholder = () => {
  const { messages } = useIntl();
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#d3d3d3' }}>
      <img
        src="/assets/icons/chat/filter_empty.svg"
        width="86px"
        height="86px"
      />
      <Typography
        style={{ marginTop: 4, fontSize: 16, color: '#B5B5B5', textAlign: 'center' }}         
        variant="body2"
        color="textSecondary"
      >{messages['empty_text']}</Typography>
    </div>
  )
}

export default EmptyPlaceholder;